import { SdNavBarController } from "./navBarController";
import app from "../sdAppModule";

app
  .controller("sdnavbarCtrl", SdNavBarController)
  .directive("animateOnChange", function ($timeout: Function, $animate: any) {
    return {
      restrict: "A",
      link: function (scope: ng.IScope, element: JQuery, attributes: ng.IAttributes) {
        scope.$watch((attributes as any).animateOnChange, function (newValue: string, oldValue: string) {
          if ($animate.enabled() && newValue != oldValue) {
            element.addClass("animated sd-presence-changed");
            $timeout(function () {
              element.removeClass("animated sd-presence-changed");
            }, 360);
          }
        });
      }
    };
  });
